import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { } from '@types/googlemaps';
import { ApiBase } from "~core/services";
import { HttpParams } from "@angular/common/http";
import { AppConstants } from "~/shared/utils/app-constants";

@Injectable()

export class SearchService extends ApiBase {

  getGoogleApiSuggestions(val: any): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append('address', val);
    params = params.append('sensor', 'false');
    return this.get('https://maps.googleapis.com/maps/api/geocode/json', { params: params }, null, false, false, false);
  }

  getProperties(searchString: string) {
    return this.get(`/properties/search?queryString=${searchString}&appName=${AppConstants.EXPLORE}`)
  }

  getMarketsSubMarkets(searchString: string, searchTags: string) {
    let params: HttpParams = new HttpParams();
    params = params.append('queryString', 'MPFMarketName:' + searchString);
    params = params.append('searchTags', searchTags);   //comma-separated string

    return this.get(`/properties/searchmarkets`, { params: params }, null, false, false)
  }

  getGoogleAutocompleteApi(val: any): Observable<any> {
    return new Observable<any[]>(observer => {
      let result: any[] = [];
      const displaySuggestions = function(predictions: any, status: google.maps.places.PlacesServiceStatus) {
        if (status.toString() === 'OK') {
          predictions.forEach(function(prediction: any) {
            result.push(prediction.description);
          });
        }
        observer.next(result);
        observer.complete();
      };
      if (val) {
        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({ input: val, componentRestrictions: { country: 'us' } }, displaySuggestions);
      }
    });
  }

  getLatLan(address: any) {
    let geocoder = new google.maps.Geocoder();
    return Observable.create(observer => {
      geocoder.geocode({ 'address': address }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          observer.next(results[0]);
          observer.complete();
        } else {
          observer.next({});
          observer.complete();
        }
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/search/services/search.service.ts